<script>
export default {
  name: 'ReminderListsTableInfo',
};
</script>

<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" class="black--text reminder-lists__table-info">info</v-icon>
    </template>
    <div>
      <div>
        First color shows current payment status,<br>
        hover over the column to show payments:
      </div>
      <div>
        <v-icon class="red--text" small>circle</v-icon>
        <span class="caption">No Payment</span>
      </div>
      <div>
        <v-icon class="orange--text" small>circle</v-icon>
        <span class="caption">Partial Payment</span>
      </div>
      <div>
        <v-icon class="green--text" small>circle</v-icon>
        <span class="caption">Full Payment</span>
      </div>
      <div>
        <v-icon class="blue--text" small>circle</v-icon>
        <span class="caption">Overpaid</span>
      </div>
      <div class="mt-2">
        Second color shows status of main booking stay
      </div>
      <div>
        <v-icon class="green--text text--lighten-2" small>circle</v-icon>
        <span class="caption">Active</span>
      </div>
      <div>
        <v-icon class="red--text text--lighten-2" small>circle</v-icon>
        <span class="caption">Cancelled (Hover to see date)</span>
      </div>
      <div class="mt-2">
        If a booking has a payment remark,<br>
        an information icon is shown next to the colors,<br>
        and can be clicked to show the remarks made.
      </div>
    </div>
  </v-tooltip>
</template>

<style lang="scss">
.reminder-lists__table-info {
  position: absolute;
  top: 16px;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Reminders/ReminderListsTableInfo.vue